import { render, staticRenderFns } from "./VerifyEmail.vue?vue&type=template&id=d07929ba"
import script from "./VerifyEmail.vue?vue&type=script&lang=js"
export * from "./VerifyEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d07929ba')) {
      api.createRecord('d07929ba', component.options)
    } else {
      api.reload('d07929ba', component.options)
    }
    module.hot.accept("./VerifyEmail.vue?vue&type=template&id=d07929ba", function () {
      api.rerender('d07929ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VerifyEmail.vue"
export default component.exports